import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../../../shared/components/notifications/notification.service';
import { DeleteConfirmDialogComponent } from '../../../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component';
import { ExpenseForListing } from '../../../../core/models/expenses/expense-for-listing.model';
import { ExpenseRequestFilter } from '../../../../core/models/expenses/expense-request-filter.model';
import { ExpenseService } from '../../../../core/services/expense.service';

@Component({
  selector: 'app-expense-list',
  standalone: false,
  templateUrl: './expense-list.component.html',
  styleUrls: ['./expense-list.component.css']
})
export class ExpenseListComponent implements OnInit {
  expenses: ExpenseForListing[] = [];
  isLoading = false;

  currentPage = 0;
  pageSize = 10;
  totalItems = 0;

  searchTerm: string | undefined = undefined;

  constructor(
    private expenseService: ExpenseService,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    const savedSearch = sessionStorage.getItem('expenses.list.search');
    const savedPage = sessionStorage.getItem('expenses.list.page');
    const savedPageSize = sessionStorage.getItem('expenses.list.pageSize');

    this.searchTerm = savedSearch !== null ? (savedSearch || undefined) : this.searchTerm;
    this.currentPage = savedPage !== null ? parseInt(savedPage, 10) || 0 : this.currentPage;
    this.pageSize = savedPageSize !== null ? parseInt(savedPageSize, 10) || this.pageSize : this.pageSize;

    this.loadExpenses();
  }

  loadExpenses(): void {
    this.isLoading = true;
    const apiPage = this.currentPage + 1;

    const filter: ExpenseRequestFilter = {
      page: apiPage,
      pageSize: this.pageSize,
      ...(this.searchTerm !== undefined && { search: this.searchTerm })
    };

    this.expenseService.getPaginatedExpenses(filter).subscribe({
      next: ({ data, pagination }) => {
        this.expenses = data;
        this.totalItems = pagination.totalItems;
        this.pageSize = pagination.itemsPerPage;
        this.currentPage = pagination.currentPage - 1;
        this.isLoading = false;
      },
      error: () => {
        this.notificationService.showError('Failed to load expenses');
        this.isLoading = false;
      }
    });
  }

  onSearchChange(): void {
    this.currentPage = 0;
    sessionStorage.setItem('expenses.list.search', this.searchTerm || '');
    sessionStorage.setItem('expenses.list.page', this.currentPage.toString());
    sessionStorage.setItem('expenses.list.pageSize', this.pageSize.toString());
    this.loadExpenses();
  }

  clearSearch(): void {
    this.searchTerm = undefined;
    this.currentPage = 0;
    sessionStorage.removeItem('expenses.list.search');
    sessionStorage.setItem('expenses.list.page', this.currentPage.toString());
    sessionStorage.setItem('expenses.list.pageSize', this.pageSize.toString());
    this.loadExpenses();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    sessionStorage.setItem('expenses.list.page', this.currentPage.toString());
    sessionStorage.setItem('expenses.list.pageSize', this.pageSize.toString());
    this.loadExpenses();
  }

  deleteExpense(id: number): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '400px',
      data: { itemName: 'this expense' }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.expenseService.softDeleteExpense(id).subscribe({
          next: () => {
            this.notificationService.showSuccess('Expense deleted successfully');
            this.loadExpenses();
          },
          error: () => this.notificationService.showError('Failed to delete expense')
        });
      }
    });
  }
}

